/*
 * @Description:
 * @Date: 2020-05-19 17:13:16
 * @LastEditors: wjx
 */

const isPservice = projectType => {
  // 是协定服务
  return +projectType === 19;
};
/*
 * 处理使时间
 * input Date 时间对象 type: 格式化字符串 'Y-M-D h:m:s'
 * */

//上个月的年月日
export function getLastMonthAndDay() {
  let nowDate = new Date();
  let year = nowDate.getFullYear();
  let month = nowDate.getMonth();
  if (month == 0) {
    month = 12;
    year = year - 1;
  }
  let lastDay = new Date(year, month, 0);
  let LastyyyyMMdd = year + '-' + month + '-' + lastDay.getDate();
  let FitstyyyyMMdd = year + '-' + month + '-' + 1;
  return [FitstyyyyMMdd, LastyyyyMMdd];
}

export function formatDate(input, type = 'Y-M-D h:m:s') {
  let time = input;
  if (typeof input === 'string' && input.length >= 6) {
    time = new Date(time);
  }
  if (!(time instanceof Date)) {
    // console.warn('注意:传入的是非时间对象', time);
    return '';
  }
  let year = time.getFullYear();
  let month = time.getMonth() + 1;
  let day = time.getDate();
  month = ('' + month).padStart(2, '0');
  day = day < 10 ? '0' + day : day;
  let hour = ('' + time.getHours()).padStart(2, '0');
  let min = ('' + time.getMinutes()).padStart(2, '0');
  let second = ('' + time.getSeconds()).padStart(2, '0');
  return String(type)
    .replace(/Y/, year)
    .replace(/M/, month)
    .replace(/D/, day)
    .replace(/h/, hour)
    .replace(/m/, min)
    .replace(/s/, second);
}
export function handleRate(key) {
  return function(prop) {
    let target = Number(prop[key]);
    if (isNaN(target)) {
      return '0';
    } else if (target >= 0) {
      return target.toFixed(2) + '%';
    } else if (target < 0) {
      return target.toFixed(2) + '%';
    }
    return '0';
  };
}

export function addQuery(ajax, query, level = 1) {
  return function(data) {
    data = Object.assign({}, query, data);
    return ajax.call(null, data);
  };
}
/*处理配置中需要默认参数的情况*/
export function addQueryToConfig(targetConfig, query) {
  if (!Array.isArray(targetConfig)) {
    console.info('注意,需要传入一个页面配置');
    return;
  }
  targetConfig.forEach(res => {
    res.childMenu.forEach(result => {
      if (result.list) {
        result.defaultQuery = query;
        result.list = addQuery(result.list, query);
      }
    });
  });
  return targetConfig;
}
export let moneyFixed = num => {
  if (!isNaN(num)) {
    let n = (Number(num) / 100).toFixed(2);
    return n + '元';
  } else {
    return '-';
  }
};
export let handleMoney = function(h, ctx, row, column, index) {
  let prop = (column || {}).property;
  if (!prop) {
    return <span>-</span>;
  }
  let value = row[prop];
  return <span>{moneyFixed(value)}</span>;
};
//geTiEnterpriseName
export const rePlaceSearchToConfig = (targetConfig, searchConfig = []) => {
  if (!Array.isArray(targetConfig)) {
    console.info('注意,需要传入一个页面配置');
    return;
  }
  targetConfig.forEach(res => {
    res.childMenu.forEach(result => {
      if (result.search) {
        result.defaultQuery = query;
        result.search = searchConfig;
      }
    });
  });
  return targetConfig;
};
// export const timeFormat = function(h, ctx, row, column, index) {
//   let target = row[column.property];
//
// };

//todo 协定服务 处理计划任务量
export const dealTaskSum = function(h, ctx, row, column, index) {
  let { projectType } = ctx.parent.defaultQuery || {};
  if (!projectType) {
    projectType = row.projectType;
  }
  let prop = column.property;
  let value = row[prop];
  if (isPservice(projectType)) {
    //协定服务
    return <span>-</span>;
  }
  return <span>{value}</span>;
};
//todo 协定服务 处理任务单价
export const dealTaskPrice = function(h, ctx, row, column, index) {
  // 从父级获取 从表格获取
  const projectType =
    (ctx.parent.defaultQuery || {}).projectType || row['projectType'];
  let prop = column.property;
  let value = row[prop];
  if (isPservice(projectType)) {
    //协定服务
    return <span>-</span>;
  }
  return <span>{moneyFixed(value)}</span>;
};
// 处理图片
export const imageHandle = function(h, ctx, row, column, index) {
  let target = row[column.property] || '';
  // target = 'https://timgsa.baidu.com/timg?image&quality=80&size=b9999_10000&sec=1595426544384&di=ab8e77f27fb5fbc47376a5a0d695ef44&imgtype=0&src=http%3A%2F%2Fpic0.qiyipic.com%2Fimage%2F20150428%2F44%2F3f%2F27%2Fv_103902518_m_601_m1_480_270.jpg';
  if (!target) {
    return <span>-</span>;
  }
  return (
    <el-image style="height: auto" src={target} preview-src-list={[target]}>
      <div slot="error">-</div>
    </el-image>
  );
};

export const formatterEmpty = function(row, col, value) {
  let target = value || row[col.property] || row[col.prop] || '';
  return target || '-';
};
export function handleTimeDate(date, outPut = '1') {
  // if (!date) {
  //   return '';
  // }
  let yearMonth = '';
  if (outPut === 'L') {
    yearMonth = formatDate(date, 'Y-M');
  } else if (outPut === 'f') {
    yearMonth = formatDate(date);
  } else if (outPut) {
    yearMonth = formatDate(date, 'Y-M-D');
  }
  return yearMonth;
}

/**
 * @description: 深拷贝
 * @param {object} target
 * @return: object
 */
export const deepClone = target => {
  let result;
  if (typeof target === 'object') {
    if (Array.isArray(target)) {
      result = [];
      for (let i in target) {
        result.push(deepClone(target[i]));
      }
    } else if (target === null) {
      result = null;
    } else if (target.constructor === RegExp) {
      result = target;
    } else {
      result = {};
      for (let i in target) {
        result[i] = deepClone(target[i]);
      }
    }
  } else {
    result = target;
  }
  return result;
};
